import { render, staticRenderFns } from "./progressButtons.vue?vue&type=template&id=2ae7de42&"
import script from "./progressButtons.vue?vue&type=script&lang=ts&"
export * from "./progressButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae7de42')) {
      api.createRecord('2ae7de42', component.options)
    } else {
      api.reload('2ae7de42', component.options)
    }
    module.hot.accept("./progressButtons.vue?vue&type=template&id=2ae7de42&", function () {
      api.rerender('2ae7de42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/progressButtons.vue"
export default component.exports